import { render, staticRenderFns } from "./HeaderLink.vue?vue&type=template&id=4456630e&"
import script from "./HeaderLink.vue?vue&type=script&lang=js&"
export * from "./HeaderLink.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports